import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FicheComponent} from './fiche/fiche.component';
import {CheckboxComponent} from './checkbox/checkbox.component';
import {DateComponent} from './date/date.component';
import {FieldComponent} from './field/field.component';
import {NirComponent} from './nir/nir.component';
import {AlertComponent} from './alert/alert.component';
import {SigninService} from './signin.service';
import {PatientsManagerService} from './patients-manager.service';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ButtonComponent} from './button/button.component';
import {PatientComponent} from './patient/patient.component';
import {CircularLoaderComponent} from './circular-loader/circular-loader.component';
import {ApiRequestService} from './api-request.service';
import {SituationComponent} from './patient/situation/situation.component';
import {SelectComponent} from './select/select.component';
import {MapToIterable} from './map-to-iterable.pipe';

@NgModule({
  declarations: [
    AppComponent,
    FicheComponent,
    CheckboxComponent,
    DateComponent,
    FieldComponent,
    NirComponent,
    AlertComponent,
    LoginComponent,
    DashboardComponent,
    ButtonComponent,
    PatientComponent,
    CircularLoaderComponent,
    SituationComponent,
    SelectComponent,
    MapToIterable
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  providers: [
    {provide: "signin", useClass: SigninService},
    {provide: "patients", useClass: PatientsManagerService},
    {provide: "apiRequest", useClass: ApiRequestService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts